import { render, staticRenderFns } from "./AppToastHost.vue?vue&type=template&id=65ffc467&"
import script from "./AppToastHost.vue?vue&type=script&lang=js&"
export * from "./AppToastHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports